import axios from "axios";
import BASE_URL from "../../../constants/baseURL";

export default async function signOut(_, { getState }) {
  const { memberDetails } = getState();
  const ida_sso_login = sessionStorage.getItem("ida_sso_login");

  await axios({
    baseURL: BASE_URL.adn_api.url + BASE_URL.adn_api.version,
    url: "/user/logout",
    method: "GET",
    headers: {
      ...(ida_sso_login === null && {
        Authorization:
          sessionStorage.getItem("authToken") || memberDetails.authToken,
      }),

      ...(ida_sso_login === "true" && {
        "x-sso-token":
          sessionStorage.getItem("authToken") || memberDetails.authToken,
      }),
      "Content-Type": "application/json",
    },
  });
}
